// Externe Bibliotheken
import React, { Component } from 'react';

// Interne Module
import * as storage from '@/_helper/storage';
import { getRegion } from '@/_helper/bookingDetailsHelper';
import tracking from '@/_helper/tracking';

// Komponenten
import Header from '@/comp/header/header';
import Footer from '@/comp/footer/Footer';
import HeroTeaser from '@/comp/heroTeaser';
import TravelFactsFull from './_comp/travelFactsFull';
import Excursion from './index/Excursion';

// Styles
import './excursion.scss';

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bookingData: storage.get('bookingData') !== null ? storage.get('bookingData') : {},
        };
    }

    componentDidMount() {
        document.title = 'Ausflüge' + window.$documentTitle;

        document.querySelector('html').classList.add('redesign');

        tracking('loaded', 'excursion');
    }

    render() {
        return (
            <div className="page-excursion">
                <Header />

                <HeroTeaser size="full" />

                <div className="content-wrapper">
                    <div className="intro row">
                        <h1 className="main-headline">
                            Ausflüge für Ihre Reise {getRegion(this.state.bookingData.data)}
                        </h1>
                    </div>

                    <TravelFactsFull />

                    <Excursion />
                </div>

                <Footer />
            </div>
        );
    }
}

export default Index;
